import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { PackageSelectorService } from '../../../../../../data-services/packages-selector-service';
import { DataFilterDisplayService } from '../../interface';

@Injectable({ providedIn: 'root' })
export class PackageOptionsDisplayService implements DataFilterDisplayService {
  constructor(private readonly packageSelectorService: PackageSelectorService) {}

  getDisplay(value: string[]): Observable<string> {
    return this.packageSelectorService.getMulti(value).pipe(
      take(1),
      map((packages) => packages.map((p) => p.name).join(', ')),
    );
  }
}
